import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PedidoConsultaInternaOutput } from 'src/app/@shared/models/consulta-detalhes-interno';
import { GoogleMapsService } from 'src/app/services/google-maps/google-maps.service';
import { BlocoDetalhesInternosComponent } from '../../bloco-detalhes-internos.component';

@Component({
  selector: 'app-aba-comprovante',
  templateUrl: './aba-comprovante.component.html',
  styleUrls: ['./aba-comprovante.component.scss'],
})
export class AbaComprovanteComponent implements OnInit {
  static Title = 'Comprovante Digitalizado';
  static Concluido = (el: FormGroup) => {
    return true;
  };

  isLoadingStreetViewThumb: boolean = true;
  detalheStreetView: string;
  @Input('pedido') pedido: PedidoConsultaInternaOutput;
  @Input('Exibir') exibir: boolean = true;
  entregaUrl: string;
  @Input() parent: BlocoDetalhesInternosComponent;
  constructor() {}
  ngOnInit() {}
}
